// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"styles_autoComplete__11kO1","input":"styles_input__2KEq8","icon":"styles_icon__2nCg6"};